import { GlobalCodeUnifyContentPackageType } from '@csp/csp-common-content-definitions';
import { StringUtil } from '@csp/csp-common-util';
import { CountryCode, Iso3166Country } from '@csp/csp-common-model';
import { CountryNames } from '../model/CountryNames';

const defaultCountry: Iso3166Country = { name: '', code: '' };

const from = (globalCodePackage: GlobalCodeUnifyContentPackageType): CountryNames => {
  const countries =
    globalCodePackage.global_code.flatMap(
      code =>
        code.countries?.map(country => ({
          name: country.name ?? '',
          code: country.code ?? '',
        })) ?? [],
    ) ?? [];

  const getCountry = (countryCode: CountryCode): Iso3166Country =>
    countries.find(country => StringUtil.equalsInsensitive(country.code, countryCode)) ?? defaultCountry;

  const getCountries = (countryCode: CountryCode[]): Iso3166Country[] => countryCode.map(getCountry);

  return {
    countries,
    getCountry,
    getCountries,
  };
};

export const CountryNamesMapper = {
  from,
};
